module.exports = __webpack_public_path__ + "static/media/mob-affi10.a22d0942.webp";